import { Button, styled } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'

interface AlwaysHoveredOutlinedButtonProps {
  selected: boolean
  error: string
}

export const AlwaysHoveredOutlinedButton = styled(Button)<AlwaysHoveredOutlinedButtonProps>(({
  selected,
  error,
}) => {
  const theme = useMinimalsTheme()
  return {
    backgroundColor: selected ? theme.palette.primary.lighter : undefined,
    borderColor:
      error === 'true' ? theme.palette.error.main : selected ? undefined : theme.palette.grey[300],
  }
})
